<template>
    <div class="participant-information row div-spacing-top">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="order-title">
                Participant Account Information
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="bs-component" style="margin-bottom: 2px;" hidden>
                        <label>Search By:</label>
                        <div class="btn-group btn-group-justified input-group">
                            <!-- <button class="btn g-color-white text-uppercase g-rounded-5 mr-1" v-bind:class="{'g-bg-main g-bg-main-blue--hover':isNameSearch}">Name</button> -->
                            <button class="btn g-color-white text-uppercase g-rounded-5 mr-1" v-bind:class="{'g-bg-main g-bg-main-blue--hover' : isActiveClassName }" v-on:click="clickSearchOption('name')">Name</button>
                            <button class="btn g-color-white text-uppercase g-rounded-5 mr-1" v-bind:class="{'g-bg-main g-bg-main-blue--hover' : isActiveClassId }" v-on:click="clickSearchOption('id')">EVF-ID</button>
                            <button class="btn g-color-white text-uppercase g-rounded-5 mr-1" v-bind:class="{'g-bg-main g-bg-main-blue--hover' : isActiveClassEmail }" v-on:click="clickSearchOption('email')">Email</button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                    <div class="input-group mb-3" style="margin-bottom:0px !important;">
                        <input type="text" class="form-control" v-on:keyup.enter="Search(searchKeyword)" v-on:focus="ViewResultsAgain()" v-model="searchKeyword" placeholder="Search.." >
                        <div class="input-group-append">
                            <button v-on:click="Search(searchKeyword)" class="btn btn-outline-secondary" type="button">Search <span><i class="fa fa-search"></i></span></button>
                        </div>
                    </div>
                </div>
                <div v-if="isDropDownShown" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-dropdown">
                    <ul v-if="isSearchResultLoaded && !noResults" class="ul-dropdown">
                        <li v-bind:id="index" v-on:click="SelectAccount(al.salesforceId)" class="list-hover" v-for="(al, index) in AccountList">
                            <span v-if='al.accountType==1' class="list-text">{{al.primaryContact.firstName}} {{al.primaryContact.lastName}}; {{al.emailAddress}}; EVF-ID: {{al.evfAccountNumber}} SF ID: {{al.salesforceId}}</span>
                            <span v-else class="list-text">{{al.primaryContact.legalName}}; {{al.emailAddress}}; EVF-ID: {{al.evfAccountNumber}} SF ID: {{al.salesforceId}}</span>
                        </li>
                    </ul>
                    <div v-else-if="noResults && isSearchResultLoaded" class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                            <p>No results found</p>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                            <img src="../../../../../static/img/loading.gif"/>
                        </div>
                    </div>
                </div>
                <div v-if="SelectedAccount" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                    <div v-if="!selectedAccountLoading" class="row">
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">Participant Name:</label> 
                                <span v-if='SelectedAccount.accountType==1' class="order-confirmation-description">{{SelectedAccount.primaryContact.firstName}} {{SelectedAccount.primaryContact.lastName}}</span>
                                <span v-else class="order-confirmation-description">{{SelectedAccount.primaryContact.legalName}}</span>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">Participant Login Email:</label> 
                                <span class="order-confirmation-description">{{SelectedAccount.emailAddress}}</span>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">EVF ID:</label> 
                                <span class="order-confirmation-description">{{SelectedAccount.evfAccountNumber}}</span>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">Salesforce ID:</label> 
                                <a href="#" v-on:click="OpenSalesForce(SelectedAccount.salesforceId)" class="order-confirmation-description">{{SelectedAccount.salesforceId}}</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedAccountLoading" class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                            <img src="../../../../../static/img/loading.gif"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>                   
    </div>
</template>
<script>
export default {
    props:['Order'],
    components:{},
    data(){
        return{
            AccountList:[],
            SelectedAccount:null,
            isDropDownShown:false,
            searchKeyword:null,
            isSearchResultLoaded:false,
            noResults:false,
            selectedAccountLoading:true,
            isActiveClassName:false,
            isActiveClassId:false,
            isActiveClassEmail:false,
            activeClass: 'g-bg-main g-bg-main-blue--hover',
        }
    },
    methods: {
        clickSearchOption(option){

            this.isActiveClassName = false
            this.isActiveClassId = false
            this.isActiveClassEmail = false

            switch (option) {
                case 'name':
                    this.isActiveClassName = true
                    alert(option)
                    break;
                case 'id':
                    this.isActiveClassId = true
                    break;
                case 'email':
                    this.isActiveClassEmail = true
                    break;
                default:
                    break;
            }
        },
        test(index){
            this.$refs.index.$el.focus();
        },
        escapeQuote(text) {
            text = text.replace(/'/g, "")
            text = escape(text)
            return text
},
        Search(search){
            this.isSearchResultLoaded = false;
            this.isDropDownShown = true;
            var _this = this;
            this.search = this.escapeQuote(search);

            axios.get('/Account/SearchAccount/' + search, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
            .then(function (response) {
                _this.isSearchResultLoaded = true;
                 _this.noResults = false;
                _this.AccountList = response.data.raw.account;
                if(response.data.raw.count == 0){
                    _this.noResults = true; 
                }
               
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        ViewResultsAgain(){
            if(this.AccountList.length > 0){
                this.isDropDownShown = true;
            }
        },
        OpenSalesForce(id) {
            var url = "https://evf.my.salesforce.com/" + id;
            var win = window.open(url, '_blank');
            win.focus();
        },
        SelectAccount(sfId){
            var _this = this;
            this.isDropDownShown = false;
            this.selectedAccountLoading = true;
            this.SelectedAccount = {};
            axios.get('account/GetBySalesforceId/' + sfId, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
            .then(function (response) {
                _this.SelectedAccount = response.data.raw;
                _this.selectedAccountLoading = false;
                _this.$emit('search',  _this.SelectedAccount);
               
            })
            .catch(function (error) {
                console.log(error);
            });

        },

    },
    created(){   
        
    }
}
</script>


// WEBPACK FOOTER //
// ParticipantAccountInformation.vue?5b294255